import React, { Component } from 'react';

class SignInOutEditHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    let { isVisible, toggleOpen, record, historyName } = this.props;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="u-editblock fadeIn" onClick={toggleOpen}>
        <div className="form-block" onClick={(e)=>{e.stopPropagation();}}>
          <div className="u-small-title">{historyName}簽到退編輯紀錄</div>
          <div className="u-table-responsive"  style={{maxHeight: '600px', overflow: 'auto', padding: '0 15px'}}>
            <table className="u-table u-table-border u-table-striped">
            <thead>
              <tr>
                <th>修改日期</th>
                <th>初始時間</th>
                <th>修改後時間</th>
                <th>修改者</th>
              </tr>
            </thead>
            <tbody>
              {
                record.map((item, index) => (
                  <tr key={index}>
                    <td>{item.updateAt}</td>
                    <td>{item.initialTime === null ? '無資料' : item.initialTime}</td>
                    <td>{item.modifiedTime}</td>
                    <td>{item.editor}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
          </div>
          <div className="u-btn-group right">
            <button className="btn btn-md cancel" onClick={
              (e) => {
                e.preventDefault();
                toggleOpen();
              }
            }>關閉</button>
          </div>
        </div>
      </div>
    )
  }
}

export default SignInOutEditHistory;